import type { GeoPointValue } from '../types';

export function decodePolyline(encoded: string): GeoPointValue[] {
  const points: GeoPointValue[] = [];
  let index = 0;
  let latitude = 0;
  let longitude = 0;
  while (index < encoded.length) {
    const lat = decodeValue(encoded, index);
    index = lat.next;
    const lng = decodeValue(encoded, index);
    index = lng.next;
    latitude += lat.value;
    longitude += lng.value;
    points.push({ lat: latitude / 1e5, lng: longitude / 1e5 });
  }
  return points;
}

function decodeValue(encoded: string, start: number) {
  let result = 0;
  let shift = 0;
  let index = start;
  let byte = 0;
  do {
    byte = encoded.charCodeAt(index++) - 63;
    result |= (byte & 0x1f) << shift;
    shift += 5;
  } while (byte >= 0x20 && index < encoded.length);
  return { value: result & 1 ? ~(result >> 1) : result >> 1, next: index };
}
